import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "I'm not Indian and not classically trained. Can I teach this?",
  a: 'Yes. The pack is written for instructors who know how to lead a room. Volume 1 starts from the basics: every step in 8-counts, a notation key and a voice cue for the 20 most-used steps. Bonus 02, The Respectful Bollywood Teaching Card, gives you pronunciation for 15 key terms and the cultural context to present them with care.'
}, {
  q: 'Is it respectful of the culture it comes from?',
  a: 'That was a design rule from page one: name the specific style, credit its source, no costumes as a joke and no caricature. Bonus 02 covers festival context (Diwali, Holi, Navratri) and what to avoid.'
}, {
  q: 'What ages and levels does it cover?',
  a: 'Kids in three age bands (4–6, 7–9, 10–12), beginners, and adult and recreational groups. The 3-Level Dial marks every step for kids, beginner or recreational, so one routine works for a mixed room.'
}, {
  q: 'Can I use it for drop-in, fitness or themed classes?',
  a: 'Yes. Volume 4 has drop-in classes at 30, 45 and 60 minutes, a dial that turns any routine into a workout or a dance night, and ready plans for date nights, hen parties, corporate teams and Diwali.'
}, {
  q: 'Is the music included?',
  a: 'No. Every routine is mapped to a BPM range and a mood, so you can use any track you are licensed to play in your setting. No song lyrics are reproduced.'
}, {
  q: 'Won’t the routines go out of date when new songs come out?',
  a: 'Volume 5 teaches the Song-to-Steps Method: turn any track into a teachable routine in five passes, written in the same 8-count format. The pack gives you routines and the system to keep making your own.'
}, {
  q: 'What if a student has a bad knee, is pregnant or is older?',
  a: 'Every Class Plan has easier options, and Bonus 03 gives low-impact swaps plus 8 clear signals for when to stop and refer to a health professional. It keeps you inside your scope: you teach dance, not medicine.'
}, {
  q: 'Can I teach online or in a small space?',
  a: 'Yes. Volume 4 includes online class adjustments, and Bonus 04, The Any-Space Setup Guide, covers small rooms, halls, outdoors and teaching on camera.'
}, {
  q: 'Is this a subscription?',
  a: 'No. One payment, and the files are yours to keep and reuse every term.'
}, {
  q: 'What format is it, and how do I get it?',
  a: 'Six landscape PDFs of 50 pages each, plus five bonus PDFs. They read well on a tablet and print cleanly. Instant download after checkout, plus an email with your files.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="paper-grain w-full bg-paper text-navy" data-id="element-86" data-mp="s242jjxwje6r">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-87" data-mp="o10nv0rlbo74">
        <div className="text-center" data-id="element-88" data-mp="nzhbhl921xam">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-89" data-mp="2zodwi053kq4m">Before you buy</p>
          <h2 id="faq-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-90" data-mp="33ppgnq57cj5f">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-91" data-mp="38n96zof6cmdq">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-92" data-mp="3ielxablbr4hn" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-display text-[15px] font-medium text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-93" data-mp="3ndosl4bi5wcf">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-teal-deep" aria-hidden="true" data-id="element-94" data-mp="221exvjuuh843" /> : <PlusIcon className="h-5 w-5 flex-none text-teal-deep" aria-hidden="true" data-id="element-95" data-mp="16om8lga5cyjz" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-navy-soft" data-id="element-96" data-mp="1go3bjpy0kyc9">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}